// TopBar.js — slim desktop top bar (lg+). Holds the real-data status chip,
// the notification bell, and the user avatar. Frontend-only; reuses existing
// endpoints/context. NO environment pill, NO tenant switcher, NO global search
// (deliberately cut — no real data source / net-new feature).
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import NotificationBell from './NotificationBell';

const initials = (u) => {
    const s = (u?.full_name || u?.username || u?.email || '').trim();
    if (!s) return 'U';
    const parts = s.split(/[\s@._-]+/).filter(Boolean);
    const two = ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase();
    return two || s[0].toUpperCase();
};

export default function TopBar() {
    const { tenantId } = useParams();
    const { user } = useAuth();
    const [pct, setPct] = useState(null);

    // Audit-ready % = the SAME aggregate as the dashboard posture donut
    // (met/total controls across active frameworks). Real data, not fabricated.
    useEffect(() => {
        if (!tenantId) return undefined;
        let alive = true;
        api.get('/frameworks/').then((r) => {
            const fws = r.data || [];
            let met = 0, tot = 0;
            for (const f of fws) { met += f.implemented_controls || 0; tot += f.total_controls || 0; }
            if (alive) setPct(tot > 0 ? Math.round((met / tot) * 100) : null);
        }).catch(() => { /* non-fatal — chip just hides */ });
        return () => { alive = false; };
    }, [tenantId]);

    return (
        <div className="hidden lg:flex flex-shrink-0 items-center justify-end gap-4 bg-white border-b border-gray-200 px-6 py-2 z-30">
            {pct !== null && (
                <span className="text-xs font-semibold text-blue-700 bg-blue-50 border border-blue-100 rounded-full px-3 py-1"
                    title="Requirements met across active frameworks">
                    Audit-ready {pct}%
                </span>
            )}
            <NotificationBell />
            <div className="w-8 h-8 rounded-full bg-slate-700 text-white text-xs font-bold flex items-center justify-center select-none"
                title={user?.email || user?.username || ''}>
                {initials(user)}
            </div>
        </div>
    );
}
